/** Update document title + OG/Twitter image tags for share link previews. */

const DEFAULT_TITLE = 'This is Zachary Gray.';
const DEFAULT_DESCRIPTION = "Been alive since '85.";
const DEFAULT_IMAGE =
  'https://media.thisiszacharygray.com/img/artwork/portrait.jpg';

export type PageMeta = {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
};

function upsertMeta(
  attr: 'property' | 'name',
  key: string,
  content: string,
) {
  let el = document.head.querySelector(
    `meta[${attr}="${key}"]`,
  ) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function setPageMeta(meta: PageMeta) {
  if (typeof document === 'undefined') return;
  const title = meta.title?.trim() || DEFAULT_TITLE;
  const description = meta.description?.trim() || DEFAULT_DESCRIPTION;
  const image = meta.image?.trim() || DEFAULT_IMAGE;
  const url =
    meta.url?.trim() ||
    (typeof window !== 'undefined' ? window.location.href : '');

  document.title = title;
  upsertMeta('property', 'og:title', title);
  upsertMeta('property', 'og:description', description);
  upsertMeta('property', 'og:image', image);
  upsertMeta('name', 'twitter:title', title);
  upsertMeta('name', 'twitter:description', description);
  upsertMeta('name', 'twitter:image', image);
  if (url) {
    upsertMeta('property', 'og:url', url);
  }
}

export function resetPageMeta() {
  setPageMeta({
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
    image: DEFAULT_IMAGE,
    url: typeof window !== 'undefined' ? window.location.origin : undefined,
  });
}

/** Canonical release artwork URL used for OG previews. */
export function releaseArtworkImageUrl(releaseId: string, artworkPath?: string) {
  const MEDIA = 'https://media.thisiszacharygray.com';
  const path = artworkPath?.trim() || '';
  if (/^https?:\/\//i.test(path)) return path;
  const fromPath = path.match(/artwork\/([a-z0-9-]+)/i)?.[1];
  const id = fromPath || releaseId.trim();
  if (!id || !/^[a-z0-9-]+$/i.test(id)) return DEFAULT_IMAGE;
  return `${MEDIA}/img/artwork/${id}.jpg`;
}
